"use strict"

import React, { useEffect, useState } from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

import ReactSelectionElement from "../../../../../widgets/ReactSelectionElement"
import { deepcopy } from "../../../../../utils"
import InfoPopover from "../../../../../widgets/InfoPopover"

const registration = {
  // TODO need translations if decide to show on LTPM in future
  smpDataTitle: (intl) => "Sample Data",
  selectTypesLabels: (intl) => "Sample Type(s)",
  avgValuesLabel: (intl) => "Average Values",
  dataTypeExplanation: (intl) =>
    "Select one or more sample source types to display on the graph. Un-selected types will not be shown on the graph. If no type(s) are selected sample data of all types will be shown. Note: This will only impact visualization of data with an associated 'sample_id'",
  avgValuesExplanation: (intl) =>
    "When 'Yes' is selected samples with shared type and timestamp will be averaged and the averaged value will be shown (e.g. for replicates taken at the same time). Note: This will only impact visualization of data with an associated 'sample_id'",
}

export default function FilterSampleObsForm({ sample_types = [], graphKey, plotConfigUpdater, intl }) {
  const [sampleTypes, setSampleTypes] = useState([])
  const [selectedTypes, setSelectedTypes] = useState([])
  const [averageValues, setAverageValues] = useState("No")
  const [graph, setGraph] = useState({})

  useEffect(() => {
    setSampleTypes(sample_types)
  }, [sample_types])

  useEffect(() => {
    setGraph(deepcopy(graphKey))
    setSelectedTypes(graphKey.sampleTypes || [])
    setAverageValues(graphKey.avgSampleData ? "Yes" : "No")
  }, [graphKey])

  return (
    <>
      <label style={{ margin: "0" }}>{registration.smpDataTitle(intl)}:</label>
      <div style={{ marginTop: "1rem" }}>
        <ReactSelectionElement
          name={"types"}
          label={registration.selectTypesLabels(intl)}
          list={sampleTypes.map((s) => {
            return { value: s }
          })}
          defaultValue={(graphKey.sampleTypes || []).map((s) => {
            return { value: s }
          })}
          onValueChange={(_, o) => {
            const op = Object.assign({}, graph)
            const opts = o.map((t) => t.value)
            setSelectedTypes(opts)
            opts.length === 0 ? delete op.sampleTypes : (op.sampleTypes = opts)
            plotConfigUpdater(op)
          }}
          info_desc={registration.dataTypeExplanation(intl)}
          required={false}
        />
      </div>
      <hr />
      <div style={{ marginBottom: "5px", display: "flex" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ margin: "0" }}>{registration.avgValuesLabel(intl)}:</label>
          &nbsp;
          <DropdownButton title={averageValues} variant={"outline-primary"} id={"average-smp-values"}>
            {["Yes", "No"].map((opt) => (
              <Dropdown.Item
                key={opt}
                onClick={() => {
                  if (opt !== averageValues) {
                    const op = Object.assign({}, graph)
                    setAverageValues(opt)
                    opt === "No" ? delete op.avgSampleData : (op.avgSampleData = true)
                    plotConfigUpdater(op)
                  }
                }}
              >
                {opt}
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <InfoPopover desc={registration.avgValuesExplanation(intl)} intl={intl} placement={"bottom"} />
        </div>
      </div>
    </>
  )
}
